// extracted by mini-css-extract-plugin
export default {"investigation":"investigation_investigation__ov6P9","label":"investigation_label__WSqQW"};